import { createContext } from "react";

export type ModuleType =
  | "orthodontics"
  | "dentistry"
  | "anamnese"
  | "employee"
  | "exam"
  | "finance account"
  | "finance entry"
  | "frequency"
  | "group"
  | "medication"
  | "patient"
  | "permission"
  | "procedure"
  | "providers"
  | "role"
  | "scheduling"
  | "report"
  | "user"
  | "voucher"
  | "budget"
  | "positions"
  | "convenants"
  | "models"
  | "modelstypes"
  | "category"
  | "crm"
  | "stock category"
  | "stock item"
  | "stock movement";

export type PermissionType =
  | "orthodontics.operations"
  | "orthodontics.finalize"
  | "dentistry.finalize"
  | "view anamnese"
  | "create anamnese"
  | "update anamnese"
  | "delete anamnese"
  | "view employee"
  | "create employee"
  | "update employee"
  | "delete employee"
  | "enable employee"
  | "disable employee"
  | "view exam"
  | "create exam"
  | "update exam"
  | "delete exam"
  | "view finance account"
  | "create finance account"
  | "update finance account"
  | "delete finance account"
  | "view finance entry"
  | "create finance entry"
  | "update finance entry"
  | "delete finance entry"
  | "pay finance entry"
  | "view frequency"
  | "create frequency"
  | "update frequency"
  | "delete frequency"
  | "view group"
  | "create group"
  | "update group"
  | "delete group"
  | "view medication"
  | "create medication"
  | "update medication"
  | "delete medication"
  | "view patient"
  | "create patient"
  | "update patient"
  | "delete patient"
  | "view procedure"
  | "create procedure"
  | "update procedure"
  | "delete procedure"
  | "view providers"
  | "create providers"
  | "update providers"
  | "delete providers"
  | "view scheduling"
  | "create scheduling"
  | "update scheduling"
  | "delete scheduling"
  | "finished scheduling"
  | "canceled scheduling"
  | "confirmed scheduling"
  | "view scheduling reports"
  | "view patient reports"
  | "view cash flow"
  | "view budgets"
  | "create budgets"
  | "edit budgets"
  | "delete budgets"
  | "view budget details"
  | "view budget reports"
  | "set budget status"
  | "view vouchers"
  | "create vouchers"
  | "edit vouchers"
  | "delete vouchers"
  | "view positions"
  | "create positions"
  | "edit positions"
  | "delete positions"
  | "view convenants"
  | "create convenants"
  | "edit convenants"
  | "delete convenants"
  | "view models"
  | "create models"
  | "edit models"
  | "delete models"
  | "view modelstypes"
  | "create modelstypes"
  | "edit modelstypes"
  | "delete modelstypes"
  | "view role"
  | "create role"
  | "update role"
  | "delete role"
  | "view user"
  | "create user"
  | "update user"
  | "delete user"
  | "view permission"
  | "create permission"
  | "update permission"
  | "delete permission"
  | "view categories"
  | "create categories"
  | "edit categories"
  | "delete categories"
  | "view crm"
  | "create crm"
  | "update crm"
  | "delete crm"
  | "view stock category"
  | "create stock category"
  | "update stock category"
  | "delete stock category"
  | "view stock item"
  | "create stock item"
  | "update stock item"
  | "delete stock item"
  | "view stock movement"
  | "create stock movement"
  | "update stock movement"
  | "delete stock movement"
  | "approve stock movement";

export interface PermissionContextType {
  hasPermission: (permission: ModuleType) => boolean;
  checkPermission: (moduleName: ModuleType, name: PermissionType) => boolean;
}

export const PermissionContext = createContext<
  PermissionContextType | undefined
>(undefined);
